// Mirrors backend pdf_utils.compute_pos_invoice (pricing_version 2).
// Rates are GST-inclusive; all discounts are applied before tax; bill discount is
// shared across lines in proportion to their net value.
const r2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export function computePosTotals(lines, discountMode, discountValue, roundOff) {
  const prepared = lines.map((l) => {
    const qty = parseInt(l.qty) || 0;
    const rate = parseFloat(l.rate) || 0;
    const gross = r2(qty * rate);
    const pct = Math.max(0, Math.min(100, parseFloat(l.discount_pct) || 0));
    const flat = Math.max(0, parseFloat(l.discount) || 0);
    const lineDisc = r2(Math.min(gross, r2(gross * pct / 100) + flat));
    return { ...l, gross, discount_amount: lineDisc, net: r2(gross - lineDisc) };
  });
  const grossTotal = r2(prepared.reduce((a, p) => a + p.gross, 0));
  const netSum = r2(prepared.reduce((a, p) => a + p.net, 0));
  const lineDiscTotal = r2(prepared.reduce((a, p) => a + p.discount_amount, 0));
  const dv = parseFloat(discountValue) || 0;
  const billDisc = discountMode === "percent"
    ? r2(netSum * Math.max(0, Math.min(100, dv)) / 100)
    : r2(Math.min(Math.max(0, dv), netSum));

  let allocated = 0;
  const shares = prepared.map((p, i) => {
    let share = (i === prepared.length - 1 || netSum === 0) ? (netSum ? r2(billDisc - allocated) : 0) : r2(billDisc * p.net / netSum);
    share = Math.max(0, Math.min(share, p.net));
    allocated = r2(allocated + share);
    return share;
  });

  let sub = 0, tax = 0, linesTotal = 0, worstLinePct = 0;
  const lineCalc = prepared.map((p, i) => {
    const total = r2(p.net - shares[i]);
    const g = (parseFloat(p.gst_rate) || 0) / 100;
    const taxable = g ? r2(total / (1 + g)) : total;
    const t = r2(total - taxable);
    sub += taxable; tax += t; linesTotal += total;
    const discLine = r2(p.discount_amount + shares[i]);
    if (p.gross > 0) worstLinePct = Math.max(worstLinePct, r2(discLine / p.gross * 100));
    return { ...p, bill_discount_share: shares[i], discount_total_line: discLine, taxable, tax, total };
  });
  linesTotal = r2(linesTotal);
  const grand = roundOff ? Math.round(linesTotal) : linesTotal;
  const rOff = roundOff ? r2(grand - linesTotal) : 0;
  const totalDiscount = r2(lineDiscTotal + billDisc);
  const effPct = grossTotal ? r2(totalDiscount / grossTotal * 100) : 0;
  return {
    gross: grossTotal, lineDisc: lineDiscTotal, billDisc, totalDiscount, effPct,
    givenPct: Math.max(effPct, worstLinePct),
    sub: r2(sub), tax: r2(tax), linesTotal, rOff, grand, lineCalc,
  };
}

/** FastAPI error detail may be a string, an object ({code,message}) or a 422 array. */
export function apiErrorMessage(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.message || JSON.stringify(d);
}
export const apiErrorCode = (e) => e?.response?.data?.detail?.code || "";
